/**
 *
 * FBSectionFieldActions
 *
 */

import React, { memo, useCallback, useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// icons
import CustomIcons from 'components/CustomIcons';
import {
  UpOutlined,
  DownOutlined,
} from '@ant-design/icons';

// hooks
import { useRefState } from "utils/hooks";


function FBSectionFieldActions({
  type,
  index,
  fieldType,
  totalLength,
  fieldTypeList,
  // actions
  onDelete,
  onMove,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-section-field-actions', type, className);
  const { t, i18n } = useTranslation();
  const label = type == 'forms' ? `${t("inputs.field")} n°${Number(index) + 1}` : `${t("absences.day")} ${Number(index) + 1}`;

  const [currentIndex, setCurrentIndex] = useState(index || 0);
  const [currentLabel, currentLabelRef, setCurrentLabel] = useRefState(label);

  useEffect(() => {
    if (index !== null && index !== undefined) {
      setCurrentIndex(currentIndex);
      const label = type == 'forms' ? `${t("inputs.field")} n°${Number(index) + 1}` : `${t("absences.day")} ${Number(index) + 1}`;
      setCurrentLabel(label);
    }
  }, [index, i18n?.language]);

  const onDeleteHandler = useCallback(() => {
    !!onDelete && onDelete(index);
  }, [onDelete, index]);

  const onMoveUpHandler = useCallback(() => {
    setCurrentIndex(prev => Number(prev) - 1);
    !!onMove && onMove(currentIndex, currentIndex - 1);
  }, [onMove, currentIndex, totalLength]);

  const onMovedownHandler = useCallback(() => {
    setCurrentIndex(prev => Number(prev) + 1);
    !!onMove && onMove(currentIndex, currentIndex + 1);
  }, [onMove, currentIndex, totalLength]);


  const getUpClass = useCallback((currentIndex) => (
    (totalLength == 0 || totalLength == 1 || currentIndex == 0) ? 'disabled' : ''
  ), [totalLength, currentIndex])
  const getDownBtn = useCallback((inx) => {
    let cls = (totalLength == 0 || totalLength == 1 || totalLength - 1 == inx) ? 'disabled' : '';
    return (
      <DownOutlined
        className={`field-actions__button field-actions__move ${cls}`}
        onClick={onMovedownHandler}
      />
    )
  }, [totalLength, index, currentIndex, onMovedownHandler])

  const fieldLabel = useMemo(() => {
    const fieldTypeLabel = fieldTypeList?.find(el => el?.key == fieldType) || '';
    return (
      <span className={`field-label ${type}`}>{currentLabel} - {fieldTypeLabel?.label}</span>
    )
  }, [type, index, currentLabel, i18n?.language]);

  return (
    <div {...rest} className={childClassNames}>
      <div className="field-wrapper">
        {fieldLabel}
      </div>
      <div className="field-actions">
        {!!onDelete && (
          <CustomIcons className={`field-actions__button ${type}`} type="garbage" onClick={onDeleteHandler} />
        )}
        {((type == 'forms') || (type == 'appointments')) && (
          <>
            <UpOutlined
              className={`field-actions__button field-actions__move ${getUpClass(currentIndex)}`}
              onClick={onMoveUpHandler}
            />
            {getDownBtn(currentIndex)}
          </>
        )}
      </div>
    </div>
  );
}

FBSectionFieldActions.defaultProps = {
  type: 'documents',
  fieldType: '',
  fieldTypeList: [],
  index: 0,
  totalLength: 0,
};
FBSectionFieldActions.propTypes = {
  type: PropTypes.oneOf(['appointments', 'forms', 'documents', 'discussion']).isRequired,
  onDelete: PropTypes.func,
  onMove: PropTypes.func,
};

export default memo(FBSectionFieldActions);
